import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { AlertTriangle } from "lucide-react";

const money = (v) => (v || 0).toLocaleString("pl-PL", { minimumFractionDigits: 2, maximumFractionDigits: 2 });

export const OverdueInvoicesPanel = () => {
  const [d, setD] = useState(null);
  const navigate = useNavigate();
  useEffect(() => { api.get("/invoices/overdue").then((r) => setD(r.data)).catch(() => {}); }, []);
  if (!d || d.invoices.length === 0) return null;
  return (
    <section className="mt-8 border border-red-200 bg-white rounded-md p-5" data-testid="overdue-invoices-panel">
      <div className="flex items-center gap-2 flex-wrap mb-3">
        <AlertTriangle className="h-4 w-4 text-red-600" />
        <h3 className="font-[Outfit] font-semibold">Płatności po terminie</h3>
        <span className="text-xs text-muted-foreground" data-testid="overdue-totals">
          {Object.entries(d.totals).map(([c, v]) => `${money(v)} ${c}`).join(" · ")}
        </span>
        <span className="text-[11px] text-muted-foreground ml-auto">Przypomnienia od Bena wysyłane automatycznie po 3 i 10 dniach</span>
      </div>
      <div className="divide-y divide-border">
        {d.invoices.slice(0, 8).map((i) => (
          <button key={i.invoice_id} onClick={() => navigate("/invoices")} className="w-full text-left flex flex-wrap items-center gap-2 py-2 text-sm hover:bg-zinc-50" data-testid={`overdue-row-${i.invoice_id}`}>
            <span className="font-medium min-w-0 flex-1 truncate">{i.number} · {i.buyer?.name}</span>
            <span className="tabular-nums">{money(i.totals?.gross)} {i.currency}</span>
            <span className="text-[11px] text-red-600 font-medium">{i.days_overdue} dni po terminie</span>
            <span className="text-[11px] text-zinc-500">przypomnienia: {(i.reminders || []).length}</span>
          </button>
        ))}
      </div>
    </section>
  );
};
